import './menu.scss';

import React, { FunctionComponent } from 'react';

import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

type MenuItemProps = {
  label: string;
  link: string;
  isSelected?: boolean;
};

export const MenuItem: FunctionComponent<MenuItemProps> = ({
  label,
  link,
  isSelected = false,
}) => {
  const { t } = useTranslation();
  return (
    <li className={classNames('menu-item', isSelected && 'menu-item-active')}>
      <a href={link}>
        {isSelected && (
          <span className="jg-sr-only">{t('menu.currentSelection')}: </span>
        )}
        {label}
      </a>
    </li>
  );
};
